import React from "react";
import {Box, Stack} from "@mui/material";
import {TemplateItem} from "./ConfigurationPanel/TemplateItem";


export const TemplatesPanel = () => {
    return (
        <Box p={2} className="templates-stack">
            <Stack alignItems="flex-start">
                {/*<SidebarButton href="#">Empty</SidebarButton>*/}
                <TemplateItem link="#sample/welcome" imageNumber={1} title={'#1 Welcome'} />
                <TemplateItem link="#sample/one-time-password" imageNumber={2} title={'#2 Otp'} />
                <TemplateItem link="#sample/reset-password" imageNumber={3} title={'#3 Reset Password'} />
                <TemplateItem link="#sample/order-ecomerce" imageNumber={4} title={'#4 Order Details'} />
                <TemplateItem link="#sample/subscription-receipt" imageNumber={5} title={'#5 Subscription'} />
                <TemplateItem link="#sample/reservation-reminder" imageNumber={6} title={'#6 Reservation'} />
                <TemplateItem link="#sample/post-metrics-report" imageNumber={7} title={'#7 Post Metrics'} />
                <TemplateItem link="#sample/respond-to-message" imageNumber={8} title={'#Respond Message'} />
            </Stack>
        </Box>
    )
}